import React, { useEffect } from "react";
import { Chip } from "@mui/material";
import { Theme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';

import GetEquipmentInfoSpecific, {
  CustomerEquipments,
} from "../utils/GetEquipmentInfo";
import EquipmentUnitIndiv from "./EquipmentUnitIndividual";
import { useLocalStorage } from "../utils/LocalStorageHook";

interface EquipmentInfoProps {
  customerData: any;
  customerNum: string;
}

interface CustomerEquipmentsState {
  isLoaded: boolean;
  equipments: CustomerEquipments[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    chipActual: {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(1),
    },
    mapContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  })
);

export default function EquipmentInfo(props: EquipmentInfoProps) {
  const classes = useStyles();
  const [state, setState] = React.useState<CustomerEquipmentsState>({
    isLoaded: false,
    equipments: [],
  });
  const [salesOrg, _] = useLocalStorage("SETTINGS.salesOrg", "");

  useEffect(() => {
    if (state.isLoaded) return;

    GetEquipmentInfoSpecific(salesOrg.toString(), props.customerNum).then(
      (v: CustomerEquipments[]) => {
        setState({
          ...state,
          isLoaded: true,
          equipments: v,
        });
      }
    );
  }, [state, props.customerNum]);

  if (!state.isLoaded || state.equipments.length < 1) {
    return <div>No equipments found.</div>;
  }

  return (
    <div className={classes.root}>
      {state.equipments.map((e, i: number) => (
        <div key={`EquipmentInfo-${i}`}>
          <Chip
            label={e.active ? "Active" : "Inactive"}
            className={classes.chipActual}
            color="primary"
          />
          <EquipmentUnitIndiv
            customerData={props.customerData}
            equipmentNum={state.equipments[0].equipmentNum}
            customerNum={props.customerNum}
            status={state.equipments[0].status}
          />
        </div>
      ))}
    </div>
  );
}
